import React from 'react';
import { Alert, Stack } from '@mui/material';

import type { CustomStep } from '@shared/patient-intake-status';

import { SingleDocumentListItem } from '../../../../../../components/DocumentManager';

type DischargeLetterStepViewerProps = {
  step: CustomStep['DISCHARGE_LETTER_UPLOAD'];
  patientId: string;
};

export const DischargeLetterStepViewer: React.FC<DischargeLetterStepViewerProps> = ({ step, patientId }) => {
  const { currentStatus } = step;

  if (!currentStatus || currentStatus.status === 'NOT_STARTED' || currentStatus.status === 'ERROR') {
    return null;
  }

  const { metadata } = currentStatus;

  if (!metadata) {
    return null;
  }

  const fileUploadDocId = metadata.fileUploadDocId;

  if (!fileUploadDocId) {
    return <Alert severity="warning">No discharge letter has been uploaded for this step yet.</Alert>;
  }

  return (
    <Stack gap={2}>
      <SingleDocumentListItem documentId={fileUploadDocId} patientId={patientId} type="PATIENT_DOCUMENT_UPLOAD" />
    </Stack>
  );
};
